import { IInputTreeProps, InputTree } from "../../../../../components/input";
import useSeatClass from "../hooks/use-seat-class";

const SelectSeatClass = (props: IInputTreeProps) => {
  const { data: seatClassList, isLoading: isLoadingSeatClass, isFetching: isFetchingSeatClass } = useSeatClass();

  const loading = isLoadingSeatClass || isFetchingSeatClass;

  const processed = {
    ...seatClassList,
    Data: seatClassList?.Data?.map((item) => ({
      Name_VN: `${item.Code} - ${item.Name_VN}`,
      Code: item.Code,
    })),
  };

  return (
    <InputTree
      {...props}
      isDisabled={loading || props.isDisabled}
      placeholder={props.placeholder || "* Chọn hạng ghế"}
      asyncData={{
        response: processed,
        pathTitle: "Name_VN",
        pathKey: "Code",
      }}
    />
  );
};

export default SelectSeatClass;
